import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { io } from 'socket.io-client';
import { getToken } from 'auth';

import envVars from 'helpers/envVars';
import useDealerId from 'hooks/useDealerId';

import { CopilotActions } from 'modules/mobiCopilot/components/CopilotActions';

const SOCKET_URI = envVars('API_COPILOT_SOCKET_URL');

export default function MobiCopilotController() {
  const dealerId = useDealerId();
  const userStore = useSelector(({ userStore }) => userStore);

  const keycloakToken = getToken();

  const socketInstance = io(SOCKET_URI, {
    path: '/socket',
    transports: ['websocket'],
  });

  const socketLogin = useCallback(() => {
    socketInstance.emit('user:login', {
      dealerId,
      email: userStore?.email,
      firstName: userStore?.firstName,
      mobiUserId: userStore?.userSite?.id,
      username: userStore?.username,
      userType: userStore?.userType,
    });
  }, [dealerId, userStore]);

  // * Closes the communication upon component unmount
  useEffect(() => {
    return () => socketInstance.off('connect');
  }, []);

  useEffect(() => {
    if (!keycloakToken) return;

    // * Establishes a new socket connection only with a valid token
    socketInstance.auth = { token: `Bearer ${keycloakToken}` };

    socketInstance.on('connect', () => socketLogin());
  }, [keycloakToken]);

  return (
    <CopilotActions
      currentUserName={userStore?.userSiteName || userStore?.firstName}
      dealerId={dealerId}
      socketInstance={socketInstance}
    />
  );
}
